import React, { FC } from "react";
import { makeStyles, Typography, Box } from "@material-ui/core";
import { formatCurrency } from "./logic";

interface PromotionProps {
  oldPrice: number;
  newPrice: number;
}
const useStyles = makeStyles((theme) => ({
  promoButton: {
    borderRadius: theme.shape.borderRadius * 3,
    padding: theme.spacing(1, 2),
    textTransform: "none",
    display: "flex",
    alignItems: "baseline",
    border: `1px solid rgba(191,219,254,1)`,
    backgroundColor: "rgba(239,246,255,1)",
    color: theme.palette.primary.dark,
    justifyContent: "center",
    "& > * + *": {
      marginLeft: theme.spacing(1),
    },
  },
  // 1) on retire le textDecoration, on ne barre plus le texte directement
  oldPrice: {
    fontSize: "0.925rem",
    color: theme.palette.text.disabled,
    position: "relative", // pour que ::after se base dessus
    zIndex: 1, // text au-dessus de la ligne
  },
  // 2) on dessine la barre avec une pseudo-classe
  oldPriceContainer: {
    display: "inline-block",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "50%", // milieu vertical
      left: "-5%", // on commence un peu avant
      width: "110%", // on dépasse un peu à droite
      height: 2, // épaisseur de la barre
      backgroundColor: theme.palette.text.disabled, // couleur rouge
      transform: "rotate(-15deg) translateY(-50%)",
      transformOrigin: "center",
      zIndex: 0, // sous le texte
    },
  },
  newPrice: {
    fontWeight: 600,
    fontSize: "1.725rem",
    color: "#4e5d78",
  },
}));

const PromotionButton: FC<PromotionProps> = ({ newPrice, oldPrice }) => {
  const classes = useStyles();

  return (
    <Box className={classes.promoButton}>
      {/* Nouveau prix */}
      <Typography variant="h6" className={classes.newPrice}>
        {formatCurrency(newPrice)}
      </Typography>

      {/* Ancien prix, on l'enferme dans un container qui va dessiner la barre */}
      <Box className={classes.oldPriceContainer}>
        <Typography variant="body2" className={classes.oldPrice}>
          {formatCurrency(oldPrice)}
        </Typography>
      </Box>
    </Box>
  );
};

export default PromotionButton;
